import { Typography,Space,Button } from "antd";
/** get items column */
import { EditOutlined, } from "@ant-design/icons";
import { TbTrashXFilled } from 'react-icons/tb';

export const columns = ({handleChoose,handleUpdateData,handleDeleteData})=>{
  const Link = Typography.Link;
  const LChoose = ({children, record}) => (
    <Link 
    className="text-select" 
    onClick={()=>handleChoose(record)} 
    // disabled={record?.active_status === 'ปิดการใช้งาน'} 
    >{children}
    </Link>
  );
  return [
    {
      title: "ชื่อรูปแบบอิงค์",
      key: "ink_name",
      dataIndex: "ink_name", 
      // width:"25%",
      render: (v, record) => <LChoose record={record}>{v}</LChoose>
    },
    {
      title: "บรรทัดที่ 1",
      dataIndex: "ink_description_1",
      key: "ink_description_1",
      width:"20%",
      render: (v, record) => <LChoose record={record}>{v}</LChoose>
    },
    {
      title: "บรรทัดที่ 2",
      dataIndex: "ink_description_2",
      key: "ink_description_2",
      width:"20%",
      render: (v, record) => <LChoose record={record}>{v}</LChoose>
    },
    // {
    //   title: "บรรทัดที่ 3",
    //   dataIndex: "ink_description_3",
    //   key: "ink_description_3",
    //   render: (v, record) => <LChoose record={record}>{v}</LChoose>
    // },
    {
      title: "ตำแหน่งพิมพ์",
      dataIndex: "ink_position",
      key: "ink_position",
      width: "14%",
      render: (v) => v || "-",
    },
    {
      title: "สีหมึก",
      dataIndex: "ink_color",
      key: "ink_color",
      width: "10%",
      render: (v) => v || "-",
    },
    {
      title: "หมายเหตุ",
      dataIndex: "ink_remark",
      key: "ink_remark",
      width: "14%",
      render: (v) => v || "-",
    },
    {
    title: "Action",
    key: "operation",
    width: "60px",
    fixed: "right",
    render: (text, record) => (
      <Space>
        <Button
          icon={<EditOutlined />}
          className="bn-primary-outline"
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={(e) => handleUpdateData(record)}
          size="small"
        />
        <Button
          danger
          icon={<TbTrashXFilled />}
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={(e) => handleDeleteData(record)}
          size="small"
        />
      </Space>
    ),
  },
  ]
};